import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  required?: boolean;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  required,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-162">
        {label && <label className="block text-sm font-medium text-text-main mb-1" data-id="element-163">
            {label}
            {required && <span className="text-primary ml-1" data-id="element-164">*</span>}
          </label>}
        <input ref={ref} className={`w-full px-4 py-2 bg-surface text-text-main border ${error ? 'border-primary' : 'border-border'} rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-colors placeholder-text-muted/50 ${className}`} {...props} data-id="element-165" />
        {error && <p className="mt-1 text-sm text-primary" data-id="element-166">{error}</p>}
      </div>;
});
Input.displayName = 'Input';